<template>
  <CCard>
    <CCardBody>
      <v-toolbar flat color="white">
        <v-toolbar-title>فاکتور فروش جدید</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>

      <v-container grid-list-md>
        <v-layout wrap>
          <v-flex xs12 sm3 md3>
            <div class="form-group">
              <label>تاریخ فاکتور</label>
              <date-picker v-model="editedItem.invoice_date"
                           type="datetime"
                           input-format="YYYY-MM-DD HH:mm:ss"
                           locale="fa" format="YYYY-MM-DD HH:mm:ss"
                           display-format="jYYYY-jMM-jDD HH:mm:ss">
              </date-picker>
              <!--                                            <pdatepicker v-model="editedItem.bill_date"-->
              <!--                                                         class="form-control"/>-->
            </div>
          </v-flex>
          <v-flex xs12 sm4 md3>
            <div class="form-group">
              <CInput
                  label="شماره شخص"
                  v-model="editedItem.contact_id"
                  :is-valid="validations.contact_id.isValid"
                  :invalid-feedback="validations.contact_id.error"
              />
              <contact-searcher v-model="editedItem.contact_id"></contact-searcher>
            </div>
          </v-flex>
          <v-flex xs12 sm4 md3>
            <div class="form-group">
              <label>دسته بندی فاکتور</label>
              <v-autocomplete
                  :items="categories.categories"
                  v-model="editedItem.invoice_category_id"
                  :item-text="(item)=>{return item.name}"
                  :item-value="(item)=>{return item.category_id}"
                  dense
              />
              <label class="text-danger" v-if="!validations.invoice_category_id.isValid">{{validations.invoice_category_id.error}}</label>
            </div>
          </v-flex>
          <v-flex xs12 sm4 md3>
            <div class="form-group">
              <label>دسته بندی اقلام خروجی</label>
              <v-autocomplete
                  v-model="addEditProductTable.output_category_id"
                  :items="categories.outputCategories"
                  :item-text="(item)=>{return item.name}"
                  :item-value="(item)=>{return item.category_id}"
                  dense
              />
              <label class="text-danger" v-if="!validations.output_category_id.isValid">{{validations.output_category_id.error}}</label>
            </div>
          </v-flex>
          <v-flex xs12 sm4 md4>
            <div class="form-group">
              <label>گروه مشتری</label>
              <v-autocomplete
                  v-model="addEditProductTable.customer_group_id"
                  :items="categories.customerGroups"
                  :item-text="(item)=>{return item.name}"
                  :item-value="(item)=>{return item.category_id}"
                  dense
              />
              <label class="text-danger" v-if="!validations.output_category_id.isValid">{{validations.output_category_id.error}}</label>
            </div>
          </v-flex>
          <v-flex xs12 sm12 md4>
            <div class="form-group">
              <label>کلیدواژه ها</label>
              <v-combobox
                  v-model="selectedTags"
                  :items="categories.tags"
                  chips
                  item-text="tag"
                  item-value="id"
                  clearable
                  multiple
                  solo>
                <template v-slot:selection="{ attrs, item, select, selected }">
                  <v-chip
                      v-bind="attrs"
                      :input-value="selected"
                      close
                      @click="select"
                      @click:close="removeTag(item)">
                    <strong>{{ item.tag }}</strong>
                  </v-chip>
                </template>
              </v-combobox>
            </div>
          </v-flex>
          <v-flex xs12 sm12 md4>
            <div class="form-group">
              <label>روش ارسال</label>
              <v-autocomplete
                  v-model="editedItem.shipping_type_id"
                  :items="categories.shippingList"
                  :item-text="(item)=>{return item.title}"
                  :item-value="(item)=>{return item.shipping_type_id}"
                  dense
              />
              <label class="text-danger" v-if="!validations.shipping_type_id.isValid">{{validations.shipping_type_id.error}}</label>
            </div>
          </v-flex>
          <v-flex xs12 sm12 md12>
            <barcode-scanner-fetch v-model="barcode_scanner_barcode" :contact_id="editedItem.contact_id">ثبت بارکد</barcode-scanner-fetch>
            <v-data-table
                :headers="addEditProductTable.headers"
                :items="editedItem.outputs"
                :hide-default-footer="true"
                sort-by="output_id"
                :disable-pagination="true"
                class="elevation-1">
              <template v-slot:item="{item}">
                <tr>
                  <td>{{ item.product_name }}</td>
                  <td>{{ item.product_model }}</td>
                  <td>
                    {{ item.barcodes.toString() }}
                  </td>
                  <td>
                    <CInput
                        v-model="item.qty"
                        @keypress="isNumber($event)"
                        :is-valid="validations.qty.isValid"
                        :invalid-feedback="validations.qty.error"
                    />
                  </td>
                  <td>
                    <div class="form-group">
                      <div class="old-price-box" v-show="item.old_price > 0">
                        <span class="op-label" v-html="item.old_price_label || ''"></span>   
                        <span class="op-price">{{  item.old_price | currency('', 0, { symbolOnLeft: false })}}</span>                                           
                      </div>
                      <money v-model="item.unit_price" v-bind="money" dir="ltr"
                             class="form-control"/>
                    </div>
                  </td>
                  <td>
                    {{ item.qty * item.unit_price | currency('', 0, { symbolOnLeft: false })}}
                  </td>
                  <td>
                    {{ item.last_buy_price | currency('', 0, { symbolOnLeft: false })}}
                  </td>
                  <td>
                    <v-icon
                        medium
                        @click="deleteProduct(item)">
                      mdi-delete
                    </v-icon>
                  </td>
                </tr>
              </template>
              <template slot="footer">
                <div class="w-100">
                  <v-data-table
                      :headers="addEditTotalTable.headers"
                      :items="editedItem.totals"
                      :hide-default-footer="true"
                      sort-by="sort_order"
                      class="elevation-1">
                    <template v-slot:item="{item}">
                      <tr>
                        <td>
                          <CInput
                              v-model="item.sort_order"
                              @keypress="isNumber($event)"
                          />
                        </td>
                        <td>
                          <CInput
                              v-model="item.name"
                          />
                        </td>
                        <td>
                          <v-autocomplete
                              v-model="item.total_category_id"
                              :items="categories.totalsCategories"
                              :item-text="(item)=>{return item.name}"
                              :item-value="(item)=>{return item.category_id}"
                              dense
                          />
                        </td>
                        <td>
                          <div class="form-group">
                            <money v-model="item.price" v-bind="money"
                                   dir="ltr"
                                   class="form-control"/>
                          </div>
                        </td>
                        <td>
                          <v-icon
                              medium
                              @click="deleteTotal(item)">
                            mdi-delete
                          </v-icon>
                        </td>
                      </tr>
                    </template>
                    <template slot="footer">
                      <CButton color="info" class="my-2 ml-2 text-white d-inline"
                               @click="addTotalTableRow()" size="sm">
                        <CIcon :content="$options.iconsSet.cilPlus"/>
                        شرح جدید
                      </CButton>

                      <CButton color="primary" class="my-2 ml-2 text-white d-inline"
                               @click="applyDiscount()" size="sm">
                        <CIcon :content="$options.iconsSet.cilCheckCircle"/>
                        ثبت تخفیف
                      </CButton>

                      <CButton color="danger" class="my-2 ml-2 text-white d-inline"
                               @click="removeDiscount()" size="sm">
                        <CIcon :content="$options.iconsSet.cilBan"/>
                        حذف تخفیف
                      </CButton>

                 
                      <v-spacer></v-spacer>
                      <p class="d-inline float-left" style="margin-top: 10px;"
                         v-if="editedItem.total_price">جمع کل:
                        {{editedItem.total_price |currency('',0, { symbolOnLeft:
                              false
                        })}}</p>
                    </template>



                  </v-data-table>
                </div>
              </template>

            </v-data-table>
          </v-flex>

          <v-flex xs12 sm4 md4>
              <CInput
                  label="نام و نام خانوادگی"
                  v-model="editedItem.customer_name"
                  :is-valid="validations.customer_name.isValid"
                  :invalid-feedback="validations.customer_name.error"
              />            
          </v-flex>          

          <v-flex xs12 sm4 md4>
              <CInput
                  label="شماره موبایل"
                  v-model="editedItem.customer_phone"
                  :is-valid="validations.customer_phone.isValid"
                  :invalid-feedback="validations.customer_phone.error"
              />
          </v-flex> 

          <v-flex xs12 sm4 md4>
            <CTextarea
                label="آدرس"
                v-model="editedItem.address"
            />
          </v-flex>



          <v-flex xs12 sm12 md12>
            <div class="form-group">
              <label>فایل ضمیمه</label>
              <v-file-input dense v-model="editedItem.fileUpload"/>
            </div>
          </v-flex>
          <v-flex xs12 sm12 md12>
            <CButton color="primary" class="mb-2 ml-2 text-white"
                     @click="save()">
              ثبت
              <CIcon :content="$options.iconsSet.cilSave"/>
            </CButton>
          </v-flex>
        </v-layout>
      </v-container>
    </CCardBody>



  </CCard>

</template>

<script>
import {
  functionAction,
  getCategoryType,
  getFunction,
  getInvoiceInfo,
  productAutoComplete,
  uploadFile,
  callWebservice,
  formatDate
} from '../../webservice/webservice';
import {iconsSet} from '../../assets/icons/icons'
import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
import moment from "moment-jalaali";


export default {
  name: 'NewInvoices',
  iconsSet,
  components: {
    datePicker: VuePersianDatetimePicker,
  },
  props: {
    items: Array,
    fields: {
      type: Array,
      default() {
        return ['username', 'registered', 'role', 'status']
      }
    },
    caption: {
      type: String,
      default: 'Table'
    },
    hover: Boolean,
    striped: Boolean,
    bordered: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean

  },
  methods: {

applyDiscount() {
  // بررسی وجود محصولات در لیست خروجی
  if (!this.editedItem.outputs || this.editedItem.outputs.length === 0) {
    alert("ابتدا محصولاتی را به لیست اضافه کنید.");
    return;
  }

  // سوال در مورد نوع تخفیف
  const isPercentage = confirm("نوع تخفیف را انتخاب کنید:\n\nبرای تخفیف 'درصدی' روی OK کلیک کنید.\nبرای تخفیف 'مقدار ثابت' روی Cancel کلیک کنید.");

  const discountCategoryId = this.categories.totalsCategories
    .find(item => item.name_original === 'تخفیف')
    ?.category_id; 

  if (isPercentage) {
    // --- حالت درصدی ---
    let percentage = prompt("درصد تخفیف را وارد کنید (مثلاً 10):");
    percentage = parseFloat(percentage);

    if (isNaN(percentage) || percentage <= 0 || percentage > 100) {
      alert("لطفاً یک درصد معتبر (بین 1 تا 100) وارد کنید.");
      return;
    }

   

    // ذخیره قیمت‌های اصلی برای بازگشت در صورت حذف
    this.appliedDiscount.type = "percentage";
    this.appliedDiscount.value = percentage;
    this.appliedDiscount.originalPrices = this.editedItem.outputs.map(item => item.unit_price);

    // اعمال تخفیف روی تک تک محصولات در outputs
    this.editedItem.outputs.forEach((item) => {
      item.unit_price = item.unit_price - (item.unit_price * (percentage / 100));
      console.log(item.unit_price);
    });

    // اضافه کردن رکورد به بخش شرح نهایی
    this.editedItem.totals.push({
      sort_order: 1,
      total_category_id: discountCategoryId,
      name: `${percentage} درصد از قیمت محصولات کم شد`,
      price: 0,
    });

  } else {
    // --- حالت مقدار ثابت ---
    let fixedAmount = prompt("مقدار ثابت تخفیف را وارد کنید:");
    fixedAmount = parseFloat(fixedAmount);

    if (isNaN(fixedAmount) || fixedAmount <= 0) {
      alert("لطفاً یک مبلغ معتبر وارد کنید.");
      return;
    }

    this.appliedDiscount.type = "fixed";
    this.appliedDiscount.value = fixedAmount;

    // اضافه کردن رکورد تخفیف به totals
    this.editedItem.totals.push({
      sort_order: 1,
      total_category_id: discountCategoryId,
      name: "تخفیف",
      price: -fixedAmount, // مقدار منفی برای کسر از کل
    });
  }

  alert("تخفیف با موفقیت ثبت شد.");
},
removeDiscount() {
  if (!this.appliedDiscount.type) {
    alert("تخفیفی برای حذف وجود ندارد.");
    return;
  }

  // 1. بازگرداندن قیمت محصولات در صورت درصدی بودن
  if (this.appliedDiscount.type === "percentage") {
    this.editedItem.outputs.forEach((item, index) => {
      if (this.appliedDiscount.originalPrices[index] !== undefined) {
        item.unit_price = this.appliedDiscount.originalPrices[index];
      }
    });
  }

  // 2. حذف رکورد از لیست totals
  const index = this.editedItem.totals.findIndex(t => 
    t.name === "تخفیف" || t.name.includes("درصد از قیمت محصولات کم شد")
  );
  
  if (index !== -1) {
    this.editedItem.totals.splice(index, 1);
  }

  // 3. ریست کردن وضعیت
  this.appliedDiscount.type = null;
  this.appliedDiscount.value = 0;
  this.appliedDiscount.originalPrices = [];
  
  alert("تخفیف حذف شد و قیمت محصولات به حالت اولیه بازگشت.");
},


    callTotalAmount() {
      let amount = 0;
      this.editedItem.outputs.map((obj) => {
        amount += parseInt(obj.qty) * parseInt(obj.unit_price);
      });
      this.editedItem.totals.map((obj) => {
          amount += parseInt(obj.price);
      });
      this.editedItem.total_price = amount;
    },
    convertJDateToDate(dt) {
      return moment(dt, 'jYYYY-jMM-jDD').format('YYYY-MM-DD')
    },
    initialize() {
      getCategoryType(this.$http, 6).then((resp) => {
        this.categories.categories = resp.list;

        getFunction(this.$http, 'shipping_types', 0, 1000, 'name', 'desc', {}).then((resp) => {
          this.categories.shippingList = resp.list;
          getCategoryType(this.$http, 2).then((resp) => {
            this.categories.outputCategories = resp.list;
            getCategoryType(this.$http, 7).then((resp) => {
              this.categories.totalsCategories = resp.list;
              getFunction(this.$http, 'tags', 0, 1000, 'name', 'desc', {}).then((resp) => {
                this.categories.tags = resp.list;
                getFunction(this.$http, 'user', 0, 1000, 'name', 'desc', {"status": "1"}).then((resp) => {
                  this.categories.users = resp.list;
                  getCategoryType(this.$http, 10).then((resp) => {
                    this.categories.revenueCategories = resp.list;
                    getFunction(this.$http, 'accounts', 0, 1000, 'name', 'desc', {}).then((resp) => {
                      this.categories.accounts = resp.list;
                    });
                  });
                });
              });
            });
          });
        });

      });
    },
    save() {

      Object.keys(this.validations).map((key) => {
        this.validations[key].error = '';
        this.validations[key].isValid = null;
      });

      for(let i=0 ; i < this.editedItem.totals.length ; i++){
        if(this.editedItem.totals[i].name == '')
          this.editedItem.totals[i].name = this.getTotalCatNameFromId(this.editedItem.totals[i].total_category_id);
      }


      functionAction(this.$http, 'invoices', 'add', this.editedItem).then((resp) => {
        if (resp.success) {
          this.$toasted.show(resp.message, {
            theme: "toasted-primary",
            position: "bottom-center",
            duration: 3000
          });

          this.editedItem = {
            "invoice_id": "",
            "customer_id": "",
            "contact_id": "",
            "invoice_category_id": "",
            "invoice_code": "",
            "order_code": "",
            "total_price": "",
            "shipping_type_id": "",
            "address": "",
            "customer_name": "",
            "customer_phone": "",
            "tags": "",
            "is_sent": "",
            "invoice_date": formatDate(new Date()),
            "attachment": "",
            "outputs":[],
            "totals":[]
          }
          this.selectedTags = [];
          this.$router.push('/sell/invoices');

        } else {
          this.$toasted.show(resp.body.message, {
            theme: "toasted-primary",
            position: "bottom-center",
            duration: 3000
          });
          let errors = resp.body.errors;
          Object.keys(errors).map((k) => {
            this.validations[k] = {isValid: false, error: errors[k]}
          });
        }

      });

    },
    isNumber: function (evt) {
      evt = (evt) ? evt : window.event;
      let charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    deleteProduct(item) {
      let index = this.editedItem.outputs.indexOf(item);
      this.editedItem.outputs.splice(index, 1);
    },
    deleteTotal(item) {
      let index = this.editedItem.totals.indexOf(item);
      this.editedItem.totals.splice(index, 1);
    },
    goToBlankRoute(routeName) {
      let routeData = '/#'  + routeName;
      window.open(routeData, '_blank');
    },
    toEnglishNumber(string) {
      return string.replace(/[\u0660-\u0669]/g, function (c) {
        return c.charCodeAt(0) - 0x0660;
      }).replace(/[\u06f0-\u06f9]/g, function (c) {
        return c.charCodeAt(0) - 0x06f0;
      })
    },
    addTotalTableRow() {
      let sort_order_last = 0;
      if(this.editedItem.totals.length > 0)
        sort_order_last = this.editedItem.totals[this.editedItem.totals.length - 1].sort_order;
      this.editedItem.totals.push({
        "total_id": "",
        "invoice_id": "",
        "bill_id": "",
        "name": "",
        "total_category_id": "",
        "price": "",
        "sort_order": (sort_order_last+1)
      })
    },
    removeTag(item) {
      this.selectedTags.splice(this.selectedTags.indexOf(item), 1);
      this.selectedTags = [...this.selectedTags]
    },
    convertDateToJDate(dt) {
      let convertedDate = moment(dt, 'YYYY-MM-DD HH:mm:ss').format('jYYYY/jM/jD HH:mm:ss');
      if (convertedDate === 'Invalid date') {
        return 'نامعلوم'
      }
      return convertedDate
    },
    openRevenueForm(item){
      this.revenueForm.Invoice = item;
      this.revenueForm.Show = true;
    },
    getTotalCatNameFromId(id){
      let selectedTotal = {name:''};
      this.categories.totalsCategories.forEach(total => { if(total.category_id == id) {selectedTotal = total;} })
      return selectedTotal.name;
    }
  },

  data: () => {
    return {
      dialog: false,



      editedIndex: -1,
      editedItem: {
        "invoice_id": "",
        "customer_id": "",
        "contact_id": "",
        "invoice_category_id": "",
        "invoice_code": "",
        "order_code": "",
        "total_price": "",
        "shipping_type_id": "",
        "address": "",
        "customer_name": "",
        "customer_phone": "",        
        "tags": "",
        "is_sent": "",
        "invoice_date": formatDate(new Date()),
        "attachment": "",
        "outputs":[],
        "totals":[],
      },
      validations: {
        total_price: {isValid: null, error: ''},
        invoice_code: {isValid: null, error: ''},
        order_code: {isValid: null, error: ''},
        output_category_id: {isValid: null, error: ''},
        invoice_category_id: {isValid: null, error: ''},
        contact_id: {isValid: null, error: ''},
        shipping_type_id: {isValid: null, error: ''},
        is_sent: {isValid: null, error: ''},
        qty: {isValid: null, error: ''},
        customer_name: {isValid: null, error: ''},
        customer_phone: {isValid: null, error: ''},
      },

      categories: {
        categories: [],
        accounts: [],
        contacts: [{
          name: "هیچکدام",
          family: "",
          contact_id: ""
        }],
        shippingList: [],
        outputCategories: [],
        totalsCategories: [],
        tags: [],
        users: [],
        revenueCategories: [],
        customerGroups: [
          {
            name: "مصرف کننده",
            category_id: "1"
          },{
            name: "همکار C",
            category_id: "2"
          },{
            name: "همکار B",
            category_id: "4"
          },{
            name: "همکار A",
            category_id: "5"
          }],
      },
      options: {},


      addEditProductTable: {
        headers: [
          {text: 'نام محصول', width: "35%"},
          {text: 'مدل', width: "10%"},
          {text: 'براکدها', width: "10%"},
          {text: 'تعداد', width: "6%"},
          {text: 'قیمت هر واحد', width: "18%"},
          {text: 'قیمت کل', width: "9%"},
          {text: 'آخرین قیمت فروخته شده', width: "9%"},
          {text: '', width: "3%"}
        ],
        products: [],
        selected: null,
        productsCount: 0,
        isLoading: false,
        search: '',
        output_category_id: '',
        customer_group_id: '1'
      },
      addEditTotalTable: {
        headers: [
          {text: 'ترتیب', width: "15%"},
          {text: 'شرح', width: "40%"},
          {text: 'زیرمجموعه', width: "20%"},
          {text: 'قیمت', width: "20%"},
          {text: '', width: "5%"}
        ],
        totalsList: []
      },
      money: {
        decimal: '',
        thousands: ',',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: false
      },

      selectedTags: [],
      tag: '',
      barcode_scanner_barcode: '',
      appliedDiscount: {
        type: null, // 'percentage' or 'fixed'
        value: 0,
        originalPrices: {}, // برای ذخیره قیمت‌های اصلی محصولات در صورت تخفیف درصدی
      },

    }
  },
  mounted() {
    this.initialize()
  },
  watch: {
    editedItem:{
      deep: true,
      handler(val) {
        this.callTotalAmount();
      }
    },
    barcode_scanner_barcode:{
      deep: true,
      handler(val) {
        //console.log('detail:');
        //console.log(val);
        let b_product = val.product;
        let b_product_option_id = b_product.product_option_id;
        let b_name = b_product.name + ' ' + b_product.tagsname;
        let b_model = b_product.model;
        let b_barcode = b_product.barcode;
        let b_sell_price = b_product.sell_price;
        let b_last_buy_price = b_product.last_buy_price;
        let b_prices = val.site_customer_group_prices;
        //console.log(b_product_option_id);
        //console.log('items:');
        let finded = false;
        for(let i = 0 ; i < this.editedItem.outputs.length ; i++){
          let target = this.editedItem.outputs[i];
          let t_product_option_id = target.product_option_id;
          let barcodeAlreadyExist = false;
          if(target.barcodes.includes(b_barcode)){
            barcodeAlreadyExist = true;
            finded = true;
          }
          //console.log(t_product_option_id + ' ' + b_product_option_id);
          if(t_product_option_id == b_product_option_id && !barcodeAlreadyExist){
            target.qty++;
            target.barcodes.push(b_barcode);
            finded = true;
          }
        }
        if(!finded){
          if(this.addEditProductTable.output_category_id != '') {
            this.editedItem.outputs.push({
              "output_id": "",
              "bill_id": "",
              "invoice_id": "",
              "product_option_id": b_product_option_id,
              "old_price": b_prices[this.addEditProductTable.customer_group_id]['old_price'],
              "old_price_label": b_prices[this.addEditProductTable.customer_group_id]['label'],
              "unit_price": b_prices[this.addEditProductTable.customer_group_id]['price'],
              "output_category_id": this.addEditProductTable.output_category_id,
              "contact_id": "",
              "qty": "1",
              "product_name": b_name,
              "product_model": b_model,
              "productSearch": '',
              "productAutoLoading": false,
              "sell_price": b_sell_price,
              "last_buy_price": b_last_buy_price,
              "barcodes": [b_barcode]
            })
          }else{
            this.$toasted.show("لطفا ابتدا دسته بندی اقلام خروجی را انتخاب کنید", {
              theme: "toasted-primary",
              position: "bottom-center",
              duration: 3000
            });
          }
        }

      }
    }

  },
}
</script>
<style>
.v-menu__content--fixed {
  z-index: 2000 !important;
}

.w-80 {
  width: 80% !important;
}

.pdatepicker input {
  text-align: center;
  direction: rtl;
  width: 100%;
  background-color: white;
  color: black;
}

.old-price-box {  
  font-size: 90%;
  width: 100%;
  display:flex;
  justify-content: space-between;
  padding: 0px 10px;  
}

.old-price-box .op-price{
  text-decoration-line: line-through;
  color: gray;
}
.old-price-box .op-label{
  
}

</style>
